import React, { useEffect, useState } from "react";
import { Box, Container, RowTow, ColumnTow } from "../components/FooterStyles";

// Covid information  - FINISH
const Covid = () => {
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {size.width > 801 ? (
        <Box
          className="covidBox"
          style={{
            width: size.width > 1280 ? "80%" : size.width > 800 ? "99%" : "80%",
            backgroundColor: "#fff",
            maxWidth: 1920,
            margin: "auto",
            padding: "109px 2rem",
            paddingTop: size.width > 700 ? 75 : 18,
            paddingBottom: size.width > 700 ? 75 : 21,
          }}
        >
          <Container style={{ margin: "initial" }}>
            <RowTow className="RowSpec">
              <ColumnTow>
                <p
                  className="font-face-rb"
                  style={{
                    color: "black",
                    flex: 1,
                    textAlign: "left",
                    fontSize: size.width > 700 ? 45 : 11,
                  }}
                >
                  COVID-19
                </p>
                <p
                  className="font-face-rb"
                  style={{
                    color: "black",
                    flex: 1,
                    textAlign: "left",
                    fontSize: size.width > 700 ? 25 : 10,
                    paddingTop: size.width > 700 ? 20 : 6,
                  }}
                >
                  Ensemble, respectons les gestes barrières.
                </p>
              </ColumnTow>
              <ColumnTow>
                <p
                  className={
                    size.width > 700 ? "font-face-rb" : "font-face-rsb"
                  }
                  style={{
                    color: "black",
                    flex: 1,
                    textAlign: "left",
                    fontSize: size.width > 700 ? 20 : 9,
                  }}
                >
                  Port du masque obligatoire
                </p>
                <p
                  className={
                    size.width > 700 ? "font-face-rb" : "font-face-rsb"
                  }
                  style={{
                    color: "black",
                    flex: 1,
                    textAlign: "left",
                    fontSize: size.width > 700 ? 20 : 9,
                    paddingTop: size.width > 700 ? 20 : 7,
                    paddingBottom: size.width > 700 ? 20 : 7,
                  }}
                >
                  Désinfection des mains
                </p>

                <p
                  className={
                    size.width > 700 ? "font-face-rb" : "font-face-rsb"
                  }
                  style={{
                    color: "black",
                    flex: 1,
                    textAlign: "left",
                    fontSize: size.width > 700 ? 20 : 9,
                  }}
                >
                  Accompagnant non autorisé
                </p>
              </ColumnTow>
            </RowTow>
          </Container>
        </Box>
      ) : (
        <svg
          width={size.width > 428 ? 428 : size.width}
          height={125}
          viewBox="0 0 428 125"
        >
          <defs>
            <style>
              {
                ".a1{fill:#fff;}.b2,.c2,.d2{fill:#1d1d1b;}.b2{font-size:20px;font-family:Raleway-ExtraBold, Raleway;font-weight:800;}.c2{font-size:14px;font-family:Raleway-Bold, Raleway;font-weight:700;}.d2{font-size:12px;font-family:Raleway-SemiBold, Raleway;font-weight:600;}"
              }
            </style>
          </defs>
          <g transform="translate(0)">
            <rect
              className="a1"
              width={428}
              height={125}
              transform="translate(0 0)"
            />
            <text className="b2" transform="translate(83 33)">
              <tspan x={-46.07} y={0}>
                {"COVID-19"}
              </tspan>
            </text>
            <text className="c2" transform="translate(37 56)">
              <tspan x={0} y={0}>
                {"Ensemble, respectons les gestes barri\xE8res."}
              </tspan>
            </text>
            <text className="d2" transform="translate(37 75)">
              <tspan x={0} y={0}>
                {"Port du masque obligatoire"}
              </tspan>
            </text>
            <text className="d2" transform="translate(37 92)">
              <tspan x={0} y={0}>
                {"D\xE9sinfection des mains"}
              </tspan>
            </text>
            <text className="d2" transform="translate(37 109)">
              <tspan x={0} y={0}>
                {"Accompagnant non autoris\xE9"}
              </tspan>
            </text>
          </g>
        </svg>
      )}
    </>
  );
};

export default Covid;
